import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <Reveal>
      <div
        className={`flex flex-col gap-4 ${
          align === "center" ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
        }`}
      >
        <div className={align === "center" ? "max-w-2xl" : "max-w-2xl"}>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            {eyebrow}
          </p>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
            {title}
          </h2>
          {description && (
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
          )}
        </div>
        {actionLabel && actionTo && (
          <Link
            to={actionTo}
            className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-500"
          >
            {actionLabel}
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
          </Link>
        )}
      </div>
    </Reveal>
  );
}